<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1"><br/>
<br/>
<br/>
<br/>
<br/>
<br/></p>
<h1 class="sgc-15 sigilNotInTOC" id="heading_id_2">THE BOOK OF<br/>
  THE DEAD<br/>
<br/></h1>
<p class="calibre6 calibre2 sgc-15 sgc-37">Elizabeth Daly<br/>
<br/>
<br/>
<br/></p>
<p class="calibre6 calibre2 sgc-15">F<span class="small">ELONY</span> &amp; M<span class="small">AYHEM</span> P<span class="small">RESS</span> • N<span class="small">EW</span> Y<span class="small">ORK</span><br/>
<br/></p>
<div class="sgc-15"><img alt="image" src="Images/frn_fig_002.png" width="100%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?40ba33d4